var map = {
	"./kaer-extra-award/package.json": "ece9",
	"./kaer-first-screen/package.json": "7735",
	"./kaer-image-single/package.json": "1fbb",
	"./kaer-news-broadcast/package.json": "400b",
	"./kaer-redpacket-card/package.json": "236a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b43";